<template>
  <div class="px-4 py-3 space-y-6">

<!-- Header -->
<div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
  <h1 class="text-xl font-semibold text-gray-800">Projets : Application Mobile</h1>

  <!-- Actions -->
  <div class="flex flex-row sm:items-center sm:space-x-2">

    <!-- Ajouter un fichier -->



    <!-- Modifier le projet (bouton noir/white text) -->
    <button   @click="openModalTicket = true"
      class="flex items-center gap-2 bg-black text-white text-sm font-semibold rounded-md px-4 py-2 mt-2 sm:mt-0 hover:bg-gray-800"
    >
      <!-- Icon Edit -->
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
           viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.862 3.487l3.651 3.651m-2.121-5.772a2.121 2.121 0 113.001 3.001L7.5 19.5 3 21l1.5-4.5L18.392 1.366z"/>
      </svg>
      Signalez un Problème
    </button>

  </div>
</div>

<!-- Modal Créer Ticket -->
<div v-if="openModalTicket" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
    <h2 class="text-lg font-semibold mb-4">Signaler un problème</h2>

    <form @submit.prevent="submitTicket">
      <div class="mb-3">
        <label class="block text-sm font-medium mb-1">Titre</label>
        <input v-model="ticket.titre" type="text" class="w-full border rounded-md px-3 py-2 text-sm" required />
      </div>

      <div class="mb-3">
        <label class="block text-sm font-medium mb-1">Sujet / Description</label>
        <textarea v-model="ticket.sujet" class="w-full border rounded-md px-3 py-2 text-sm" rows="4" required></textarea>
      </div>

      <div class="mb-3">
        <label class="block text-sm font-medium mb-1">Type</label>
        <select v-model="ticket.type" class="w-full border rounded-md px-3 py-2 text-sm">
          <option>Question</option>
          <option>Bug</option>
          <option>Amélioration</option>
        </select>
      </div>

      <div class="flex justify-end space-x-2 mt-4">
        <button type="button" @click="openModalTicket = false" class="px-4 py-2 border rounded-md text-sm">Annuler</button>
        <button type="submit" class="px-4 py-2 bg-black text-white rounded-md text-sm">Envoyer</button>
      </div>
    </form>
  </div>
</div>

    <div class="mx-auto space-y-6">
      <!-- Work Process Section -->
      <section
        class="bg-white rounded-lg p-5 grid  md:grid-cols-3 gap-6"
      >
        <!-- Left side: To-do list -->
<div class="md:col-span-2 flex flex-col">
<!-- Bloc projet -->
<div class="mb-6">
  <!-- Titre du projet -->
  <h1 class="text-lg font-semibold mb-3">
    <span v-if="!edit">{{ project.title }}</span>
    <input
      v-else
      v-model="project.title"
      class="bg-transparent focus:outline-none text-lg font-semibold w-full"
    />
  </h1>

  <!-- Description -->
 <p class="text-[#6B7280] text-sm leading-relaxed max-w-4xl mb-6">
    <span v-if="!edit">{{ descriptionToShow }}</span>
    <textarea
      v-else
      v-model="project.description"
      class="bg-transparent focus:outline-none text-sm leading-relaxed w-full resize-none"
      rows="3"
    ></textarea>
    <span
      v-if="!edit && project.description.length > maxLength"
      class="text-[#F97316] cursor-pointer ml-1"
      @click="toggleShowAll"
    >
      {{ showAll ? "Voir moins" : "Voir tous" }}
    </span>
  </p>
</div>


  <!-- Documents attachés -->
<div class="mb-10">
    <h2 class="font-semibold text-sm mb-4">Documents Attachés</h2>
    <div class="flex gap-4 flex-wrap">
      <div 
        v-for="doc in allDocuments" 
        :key="doc.id"
        :class="['rounded-md w-24 py-4 px-3 flex flex-col items-center cursor-pointer', doc.bgColor]"
       @click="openDocument(doc.url)"

      >
        <img 
          :alt="`Icône document ${doc.extension.toUpperCase()}`" 
          class="mb-2" 
          height="48" 
          :src="doc.icon" 
          width="40"
        />
        <span class="text-xs font-semibold text-center truncate w-full">{{ doc.nom }}</span>
      </div>
    </div>
  </div>

<section>
  <div class="flex justify-between mb-8">
    <h2 class="font-semibold text-lg">Étapes</h2>
    <div class="flex gap-2">
      <button v-if="edit"
        @click="addStep"
        class="flex items-center gap-2 border border-gray-300 text-sm font-semibold rounded-md px-4 py-2 hover:bg-gray-100"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
             viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 10l-4-4m0 0l-4 4m4-4v12"/>
        </svg>
        Ajouter une Étape
      </button>

    </div>
  </div>

  <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr class="text-left text-sm font-semibold text-gray-900 border-b border-gray-300">
          <th class="px-6 py-3">Étapes</th>
          <th class="px-6 py-3">Tâche</th>
          <th class="px-6 py-3">Durée</th>
          <th class="px-6 py-3">Timeline</th>
          <th class="px-6 py-3">Statut</th>
        </tr>
      </thead>

<tbody class="bg-white divide-y divide-gray-200">
  <tr v-for="(step, index) in project.etapes" :key="index" class="border-b border-gray-200">
    <!-- Étape -->
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex gap-2 items-center">
      <div class="flex flex-col items-center">
        <div class="w-3 h-3 rounded-full"
             :class="step.status === 'Terminé' ? 'bg-green-500' : step.status === 'delayed' ? 'bg-red-500' : 'bg-yellow-500'">
        </div>
      </div>
      <input
        v-model="step.titre"
        :readonly="!edit"
        placeholder="Nouvelle étape"
        class="bg-transparent focus:outline-none text-sm text-gray-900 w-full"
      />
    </td>

    <!-- Tâches -->
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
      <div v-for="(task, tIndex) in step.taches" :key="tIndex" class="mb-1">
        <input
          v-model="task.description"
          :readonly="!edit"
          placeholder="Nouvelle tâche"
          class="bg-transparent focus:outline-none text-sm text-gray-900 w-full"
        />
      </div>
      <button
        v-if="edit"
        @click="step.taches.push({ description: '', status: 'En attente', pieceJointe: [] })"
        class="text-xs text-blue-500 hover:underline"
      >
        Ajouter une tâche
      </button>
    </td>

    <!-- Durée -->
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
      <input
        v-model="step.tempsNecessaire"
        :readonly="!edit"
        placeholder="-"
        class="bg-transparent focus:outline-none text-sm text-gray-900 w-full"
      />
    </td>

    <!-- Timeline -->
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
<input
  v-model="step.timeline.fin"
  type="date"
  :readonly="!edit"
  class="bg-transparent focus:outline-none text-sm text-gray-900 w-full"
/>
    </td>

    <!-- Bouton terminer -->
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
      <button
  v-if="edit"
  @click="updateStepStatuses(index)"
  class="p-2 rounded-full hover:bg-gray-200 transition"
>
        <svg xmlns="http://www.w3.org/2000/svg"
             class="h-5 w-5"
             :class="step.status === 'Terminé' ? 'text-green-500' : 'text-gray-400'"
             fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M5 13l4 4L19 7" />
        </svg>
      </button>
    </td>
  </tr>
</tbody>


    </table>
  </div>
</section>


</div>



<!-- Right side -->
<aside class="space-y-6 border-l border-gray-100 pl-6">
  <!-- Informations projet -->
  <div>
    <h3 class="text-xs font-semibold text-gray-600 uppercase mb-2">
      Informations du projet
    </h3>
    <div class="bg-[#F3F5F7] text-xs text-gray-900 p-4 rounded-md leading-relaxed max-w-[320px] space-y-2">
      <p class="flex justify-between">
        <span class="text-gray-600">Total du projet :</span>
        <span class="font-semibold"> {{ project.total }} €</span>
      </p>
      <p class="flex justify-between">
        <span class="text-gray-600">Total payé :</span>
        <span class="font-semibold text-green-600">{{ project.montantPaye }} €</span>
      </p>
      <p class="flex justify-between">
        <span class="text-gray-600">Reste dû :</span>
        <span class="font-semibold text-red-500">{{project.resteAPayer}} €</span>
      </p>
      <p class="flex justify-between">
        <span class="text-gray-600">Date de livraison :</span>
 <span class="font-semibold">
  {{ new Date(project.timeline.fin).toLocaleDateString('fr-FR') }}
</span>

      </p>
      <p class="flex justify-between">
        <span class="text-gray-600">Statut :</span>
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-700">
          <span class="w-2 h-2 bg-yellow-500 rounded-full"></span> {{project.statut}}
        </span>
      </p>
    </div>
  </div>

<!-- Fichier Projets -->
<div class="space-y-4">
  <h3 class="text-xs font-semibold text-gray-600 uppercase">
    Fichiers Projets
  </h3>

  <div
    v-for="(file, index) in project.fichiersAssocies"
    :key="index"
    class="flex items-center justify-between bg-[#F3F5F7] rounded-md p-3 max-w-[320px]"
  >
    <div class="flex items-center space-x-3">
      <div
        aria-hidden="true"
        class="bg-white rounded-full p-3 flex items-center justify-center text-gray-600"
      >
        <i class="fas fa-link text-lg"></i>
      </div>
      <div class="text-xs">
        <p class="font-semibold text-gray-900 leading-tight truncate max-w-[200px]">
          {{ file.name }}
        </p>
      </div>
    </div>

     <button
    type="button"
    @click="viewFile(file)"
    class="flex items-center space-x-1 text-gray-700 border border-gray-300 rounded-md py-1.5 px-3 text-xs font-semibold hover:bg-gray-200"
  >
    <i class="far fa-eye"></i>
    <span>Télécharger</span>
  </button>
  </div>
</div>


</aside>

      </section>
    </div>
</div>
</template>

<script setup>
import axios from "axios";
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const project = ref({
  title: '',
  description: '',
  total: 2400,
  etapes: [],
  tempsNecessaire: 0,
  timeline: { fin: null },
  fichiersAssocies: [],
  devis: [],
  factures: []
});



const edit = ref(false);

// --- Mise à jour des statuts des étapes ---
const updateStepStatuses = (finishedIndex) => {
  project.value.etapes.forEach((step, i) => {
    if (i < finishedIndex) step.status = "Terminé";
    else if (i === finishedIndex) step.status = "Terminé";
    else if (i === finishedIndex + 1) step.status = "En cours";
    else step.status = "En attente";
  });
};

async function viewFile(file) {
  try {
    const response = await fetch(file.url, { mode: 'cors' });
    if (!response.ok) throw new Error('Erreur téléchargement fichier');

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = file.name || 'fichier';
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Erreur lors du téléchargement du fichier :', err);
  }
}


// --- Récupérer le projet depuis l'API ---
// --- Fetch Project ---
const fetchProject = async () => {
  try {
    const { id } = route.params;
    const token = localStorage.getItem("token");
    const response = await axios.get(`https://datafuseweb-95a5588f8542.herokuapp.com/api/project/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    project.value = response.data;
    console.log(project.value)
  } catch (error) {
    console.error("Erreur lors de la récupération du projet :", error);
  }
};
fetchProject();

// --- Icônes et couleurs ---
const ICONS = {
  pdf: "https://www.svgrepo.com/show/424860/pdf-file-type.svg",
  docx: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/.docx_icon.svg/1200px-.docx_icon.svg.png"
};

const COLORS = {
  pdf: "bg-[#FFF1F0]",
  docx: "bg-white shadow-lg"
};

// --- Créer un tableau combiné de tous les documents ---
const allDocuments = computed(() => {
  if (!project.value) return [];

  const docs = [];

  const buildPdfUrl = (type, id) => {
    const projectId = project.value.id;
    return `https://datafuseweb-95a5588f8542.herokuapp.com/api/project/${projectId}/${type}/${id}/pdf`;
  };
  console.log()

  // Devis
  project.value.devis.forEach(d => {
    if (d.id) {
      docs.push({
        id: d.id,
        nom: "DEVIS",
        url: buildPdfUrl("devis", d.id),
        extension: "pdf",
        icon: ICONS.pdf,
        bgColor: COLORS.pdf,
        size: "—"
      });
    }
  });

  // Factures
  project.value.factures.forEach(f => {
    if (f.id) {
      docs.push({
        id: f.id,
        nom: "FACTURE",
        url: buildPdfUrl("factures", f.id),
        extension: "pdf",
        icon: ICONS.pdf,
        bgColor: COLORS.pdf,
        size: "—"
      });
    }
  });

  return docs;
});

 const openModalTicket = ref(false);
    const ticket = ref({
      titre: "",
      sujet: "",
      type: "Question",
    });

    // --- Créer un ticket ---
    const submitTicket = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          "https://datafuseweb-95a5588f8542.herokuapp.com/api/tickets",
          {
            projetId: project.value.id,
            titre: ticket.value.titre,
            sujet: ticket.value.sujet,
            type: ticket.value.type,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        console.log("Ticket créé :", response.data.ticket);
        openModalTicket.value = false;
        ticket.value = { titre: "", sujet: "", type: "Question" };
        alert("Ticket créé avec succès !");
      } catch (err) {
        console.error("Erreur création ticket :", err);
        alert("Erreur lors de la création du ticket");
      }
    };

// --- Ouvrir le document ---
// --- Ouvrir le document ---
const openDocument = async (url) => {
  try {
    const token = localStorage.getItem("token");
    console.log("📂 Tentative ouverture document :", url);

    const response = await fetch(url, { 
      headers: { Authorization: `Bearer ${token}` }
    });

    console.log("📡 Réponse fetch :", response.status, response.statusText);

    if (!response.ok) throw new Error(`Erreur téléchargement fichier : ${response.status}`);

    const blob = await response.blob();
    console.log("📑 Type de fichier reçu :", blob.type, "Taille :", blob.size);

    // Forcer le type MIME PDF si vide
    const isPdf = url.endsWith(".pdf") || blob.type === "" || blob.type === "application/octet-stream";
    const fileBlob = isPdf ? new Blob([blob], { type: "application/pdf" }) : blob;

    const fileURL = window.URL.createObjectURL(fileBlob);
    console.log("✅ URL créée pour affichage :", fileURL);

    window.open(fileURL, "_blank");
  } catch (err) {
    console.error("❌ Erreur lors de l’ouverture du document :", err);
    alert("Impossible d'ouvrir le document");
  }
};
// --- Description tronquée ---
const maxLength = 250;
const showAll = ref(false);
const descriptionToShow = computed(() => {
  if (edit.value || showAll.value) return project.value.description;
  return project.value.description.length > maxLength
    ? project.value.description.slice(0, maxLength) + "..."
    : project.value.description;
});
const toggleShowAll = () => { showAll.value = !showAll.value; };



// --- Ajouter une étape ---
const addStep = () => {
  if (!project.value.etapes) project.value.etapes = [];
  project.value.etapes.push({
    titre: "Nouvelle étape",
    taches: [],
    status: "En attente",
    tempsNecessaire: 0,
    timeline: { fin: null },
  });
};





onMounted(fetchProject);
</script>





<style scoped>
.clip-path-chevron-right {
  clip-path: polygon(0 0, 100% 50%, 0 100%);
  pointer-events: none;
}
</style>
